import React from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import LanguageForm from '../../../components/forms/LanguageForm';
import { useCreateLanguage } from '../../../hooks/useLanguageApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { LanguageDTO } from '../../../services/apiClient';

const LanguageCreate: React.FC = () => {
  const createLanguage = useCreateLanguage();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Languages', href: '/admin/languages' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: LanguageDTO) => {
    createLanguage.mutate(data, {
      onSuccess: () => {
        navigate('/admin/languages');
      },
      onError: (error) => {
        console.error('Error creating Language:', error);
      },
    });
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/languages"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.Language.Edit"
    >
        <LanguageForm
          initialValues={{} as LanguageDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/languages')}
        />
    </AdminLayout>
  );
};

export default LanguageCreate;
